<div class="control__wrapper bg-light">
    <div [ngClass]="{ 'control__shadow':
        control.elementVal.getValue()?.duringChange === 't' }">
    </div>
    <img class="control__img bg-style border-light"
        [ngClass]="{ 'bg-inactive': control.elementVal.getValue()?.duringChange === 't',
            'bg-style': control.elementVal.getValue()?.duringChange === 'f',
            'bg-style__icon': control.elementVal.getValue()?.duringChange === 'f' }"
        ngSrc="{{ setIcon(control.elementVal.getValue()?.iconId) }}"
        width="40" height="40" alt="" />
    <h2 class="control__title"
        [ngClass]="{ 'bg-inactive': control.elementVal.getValue()?.duringChange === 't',
            'bg-style': control.elementVal.getValue()?.duringChange === 'f',
            'bg-style__label': control.elementVal.getValue()?.duringChange === 'f' }">
        {{ subtitle(control.elementVal.getValue()?.txtId) }}
    </h2>
    <div class="control__content">
        <div class="control__range control__range--time-mode box-shadow">
            <h4 class="color-basic">{{ subtitle(2010) }}</h4>
            <div class="control__value color-style font-55 font-bold"
                 data-testid="temperature">
                {{ control.elementVal.getValue()?.params.value
                    | format:control.elementVal.getValue()?.params.type
                }}
            </div>
            <div class="control__min color-basic font-14">
                <p>
                    <span>{{ subtitle(395) }}</span>
                    <span>
                        {{ control.elementVal.getValue()?.params.min
                            | format:control.elementVal.getValue()?.params.type
                        }}
                    </span>
                </p>
            </div>
            <div class="control__max color-basic font-14">
                <p>
                    <span>{{ subtitle(1064) }}</span>
                    <span>
                        {{ control.elementVal.getValue()?.params.max
                            | format:control.elementVal.getValue()?.params.type
                        }}
                    </span>
                </p>
            </div>

            <input class="control__input-range cursor-pointer"
                   type="range"
                   step="1"
                   min="{{ control.elementVal.getValue()?.params.min }}"
                   max="{{ control.elementVal.getValue()?.params.max }}"
                   value="{{ control.elementVal.getValue()?.params.value }}"
                   [(ngModel)]="control.elementVal.getValue()?.params.value" />
            <div class="control__remove cursor-pointer" data-testid="decreaseTemperature">
                <hold-wrapper (onAction)="control.reduceVal()">
                    <img ngSrc="/assets/img/icons/minus.svg"
                         width="40" height="40" alt="" />
                </hold-wrapper>
            </div>
            <div class="control__add cursor-pointer" data-testid="increaseTemperature">
                <hold-wrapper (onAction)="control.increaseVal()">
                    <img ngSrc="/assets/img/icons/plus.svg"
                         width="40" height="40" alt="" />
                </hold-wrapper>
            </div>
        </div>
        <div class="control__range control__range--time-mode box-shadow">
            <h4 class="color-basic">{{ subtitle(1352) }}</h4>
            <div class="control__value color-style font-55 font-bold"
                 data-testid="time">
                 {{ control.elementVal.getValue()?.params.timeValue | format:13 }}
            </div>
            <div class="control__min color-basic font-14">
                <p>
                    <span>{{ subtitle(395) }}</span>
                    <span>
                        {{ control.elementVal.getValue()?.params.timeMin | format:13 }}
                    </span>
                </p>
            </div>
            <div class="control__max color-basic font-14">
                <p>
                    <span>{{ subtitle(1064) }}</span>
                    <span>
                        {{ control.elementVal.getValue()?.params.timeMax | format:13 }}
                    </span>
                </p>
            </div>
            <input class="control__input-range cursor-pointer"
                   type="range"
                   step="1"
                   min="{{ control.elementVal.getValue()?.params.timeMin }}"
                   max="{{ control.elementVal.getValue()?.params.timeMax }}"
                   value="{{ control.elementVal.getValue()?.params.timeValue }}"
                   [(ngModel)]="control.elementVal.getValue()?.params.timeValue" />
            <div class="control__remove cursor-pointer" data-testid="decreaseTime">
                <hold-wrapper (onAction)="control.reduceTime()">
                    <img ngSrc="/assets/img/icons/minus.svg"
                        width="40" height="40" alt="" />
                </hold-wrapper>
            </div>
            <div class="control__add cursor-pointer" data-testid="increaseTime">
                <hold-wrapper (onAction)="control.increaseTime()">
                    <img ngSrc="/assets/img/icons/plus.svg"
                         width="40" height="40" alt="" />
                </hold-wrapper>
            </div>
        </div>
        <div class="control__group-btn control__group-btn--column control__group-btn--big box-shadow"
             *ngIf="control.element.getValue()?.params.value >= 0
             && control.element.getValue()?.params.timeValue >= 0
             && control.elementVal.getValue()?.params.remoteReset">
            <p class="font-18 font-bold color-basic">{{ subtitle(3960) }}</p>
            <p class="font-15 color-basic">
                <span>
                    {{ subtitle(2010) + ': ' + (control.element.getValue()?.params.value
                        | format:control.element.getValue()?.params.type) }}
                </span>
            </p>
            <p class="font-15 color-basic">
                <span>
                    {{ subtitle(1352) + ': ' + (control.element.getValue()?.params.timeValue
                        | format:13) }}
                </span>
            </p>
            <button class="control__button bg-cancel font-15 color-light"
                (click)="control.resetTempTime()">
                <span class="control__datepicker-set-now">
                    {{ subtitle(1809) }}
                </span>
            </button>
        </div>
    </div>
    <div class="control__group-btn">
        <button class="control__button bg-default bg-default__button control__button--shadow-active"
            data-testid="goBackButton"
            (click)="control.hideControl()">
            <img class="control__button-img"
                ngSrc="/assets/img/zone_icons/back.svg"
                width="40" height="40" alt="" />
        </button>
        <button class="control__button control__button--small bg-default"
            data-testid="resetButton"
            (click)="control.setDefaultTempTime()">
            <img class="control__button-img"
                ngSrc="/assets/img/icons/return.svg"
                width="40" height="40" alt="" />
        </button>
        <button class="control__button"
            [ngClass]="{ 'bg-default': control.elementVal.getValue()?.duringChange === 't',
                'bg-ok': control.elementVal.getValue()?.duringChange === 'f',
                'bg-ok--accept': control.elementVal.getValue()?.duringChange === 'f' }"
                data-testid="sendButton"
                (click)="control.returnTempTime()">
            <img class="control__button-img"
                ngSrc="/assets/img/icons/ok.svg"
                width="40" height="40" alt="" />
        </button>
    </div>
    <div *ngIf="control.elementVal.getValue()?.duringChange === 't'"
         class="control__during-change">
        <p class="color-alarm font-18">{{ subtitle(3162) }}</p>
    </div>
</div>
